const dashRE = /-/g
const lodashRE = /_/g

export const jwtDecode = (token: string) => {
  const base64Url = token.split(".")[1]
  if (base64Url === undefined) return null
  const base64 = base64Url.replace(dashRE, "+").replace(lodashRE, "/")
  const jsonStr = decodeURIComponent(atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''))
  return JSON.parse(jsonStr)
}
